import type { ColorPalette } from '@/features/colors/color.types';
import {
  NEUTRAL_COOL,
  NEUTRAL_GRAY,
  NEUTRAL_WARM,
} from '@/features/colors/neutrals';

// Slots in design's column order: red, orange, yellow, tan, green, blue,
// purple, gray — note tan is color6, not color3. Shades by role: 500 primary
// accent, 300 muted, 100 light category, 50 shaded cell.
//
// Like the other sheet palettes, Daylight's sheet omits the warm/cool row, so
// the tie follows joyful's convention for the same eight columns.
export const daylightPalette: ColorPalette = {
  id: 'daylight',
  name: 'Daylight',
  description: 'Warm but airy',
  requiresPaidPlan: true,
  colors: {
    cool: { ...NEUTRAL_COOL },
    gray: { ...NEUTRAL_GRAY },
    warm: { ...NEUTRAL_WARM },
    color0: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#FFEFED',
        '100': '#FAE3DF',
        '300': '#DCA29E',
        '500': '#C0564E',
      },
    },
    color1: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#FDF1E9',
        '100': '#FFF4EB',
        '300': '#E0B694',
        '500': '#C67B3C',
      },
    },
    color2: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#F8F3E5',
        '100': '#FFFAE9',
        '300': '#EAD595',
        '500': '#D8B33F',
      },
    },
    color3: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#F0F5F0',
        '100': '#EDF3EA',
        '300': '#AFBFAF',
        '500': '#6E8A6E',
      },
    },
    color4: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#F0F4F9',
        '100': '#E9EEF6',
        '300': '#AFBCCE',
        '500': '#6E86A6',
      },
    },
    color5: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#F4F2FA',
        '100': '#F0E9F8',
        '300': '#B8B0CA',
        '500': '#7E6F9E',
      },
    },
    color6: {
      neutral: { ...NEUTRAL_WARM },
      shade: {
        '50': '#F6F3F0',
        '100': '#F4F0EF',
        '300': '#C9BCB1',
        '500': '#9C8571',
      },
    },
    color7: {
      neutral: { ...NEUTRAL_COOL },
      shade: {
        '50': '#D3D4D5',
        '100': '#EFEEEA',
        '300': '#8A8A8A',
        '500': '#6E6F73',
      },
    },
  },
};
